/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_SubmitInputs */

const en_admin_users_credits_submit = /** @type {(inputs: Admin_Users_Credits_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

const zh_admin_users_credits_submit = /** @type {(inputs: Admin_Users_Credits_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Admin_Users_Credits_SubmitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_submit = /** @type {((inputs?: Admin_Users_Credits_SubmitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_SubmitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_credits_submit(inputs)
	return zh_admin_users_credits_submit(inputs)
});
export { admin_users_credits_submit as "admin.users.credits_submit" }